import * as dynamicFieldsService from '../../../../services/api/dynamic-fields-api';
import { FIELD_TYPES } from './utils';

const updateDynamicTableField = (field, setDynamicFields) => {
    setDynamicFields((oldDynamicFields) =>
        oldDynamicFields.map((oldField) =>
            oldField.Id === field.Id
                ? {
                    ...oldField,
                    Table: field.Table,
                    touched: true,
                }
                : oldField
        )
    );
}

// api call to fetch dynamic fields
export async function getDynamicFields(DynamicFieldRequestDto) {
    try {
        const dynamicFields = await dynamicFieldsService.getDynamicFields(DynamicFieldRequestDto);

        return dynamicFields.map((field) => {
            const { FieldType, Data } = field;
            const parsedData =
                FieldType === FIELD_TYPES.date && Data != null && Data !== ''
                    ? new Date(Data)
                    : Data;

            return {
                ...field,
                Data: parsedData ?? '',
            };
        });
    } catch (error) {
        console.error(error);
        return [];
    }
}

export function deleteDynamicTableRowHandler(field, row, setDynamicFields, sortedData = undefined, setSortedData = undefined, isForm = false) {
    const rowToDelete = field.Table.Rows.find((r) => r.Row === row);

    if (!rowToDelete)
        return;

    field.Table.Rows = field.Table.Rows.filter((r) => r.Row !== row);
    if(sortedData){
        setSortedData(sortedData.filter((r) => r.Row !== row))
    }
    if(isForm){
        setDynamicFields(field);
    }
    else
    {
        updateDynamicTableField(field, setDynamicFields);
    }
}

export function createNewDynamicTableRowHandler(field, setDynamicFields, sortedData = undefined, setSortedData = undefined, isForm = false) {
    let lastRow = field.Table.Rows[field.Table.Rows.length - 1];

    if (!lastRow) {
        lastRow = { Row: 0 };
    }

    const newRowData = field.Table.Columns.map(column => {
        return {
            Id: 0,
            Value: '',
            ColumnId: column.Id,
            ColumnType: column.Type,
            LookupValues: column.LookupValues ? column.LookupValues?.trim()?.split(',')?.map(item => item.trim()) : null,
            ColumnLockStatus : column.LockStatus
        }
    });

    field.Table.Rows = [...field.Table.Rows, { Id: 0, Row: lastRow.Row + 1, Data: newRowData, IsVisible: true }]
    if(sortedData){
        setSortedData(field.Table.Rows)
    }
    if(isForm){
        setDynamicFields(field);
    }
    else
    {
        updateDynamicTableField(field, setDynamicFields);
    }
}

// change handler for input field
export const createDynamicInputChangeHandler = ({ field, setDynamicFields, isForm = false }) => {
    if (field.FieldType === 'Table') {
        return function (row, columnId, newValue) {
            const existingRow = field.Table.Rows.find((r) => r.Row === row);

            if (!existingRow)
                return;

            existingRow.Data = existingRow.Data.map(oldData => oldData.ColumnId === columnId ? { ...oldData, Value: newValue } : oldData)
            field.Table.Rows = field.Table.Rows.map((prevRow) => prevRow.Row === row ? { ...prevRow, ...existingRow } : prevRow);
            if(isForm){
                setDynamicFields(field);
            }
            else{
                updateDynamicTableField(field, setDynamicFields);
            }
        }
    } else if (field.FieldType === 'File') {
        return function (event) {
            const Data = '';
            const Files = event.target.value;
            setDynamicFields((oldDynamicFields) =>
                oldDynamicFields.map((oldField) =>
                    oldField.Id === field.Id
                        ? {
                            ...oldField,
                            Data,
                            touched: true,
                            Files,
                        }
                        : oldField
                )
            );
        };
    } else {
        return function (event) {
            const Data = event.target.value;
            setDynamicFields((oldDynamicFields) =>
                oldDynamicFields.map((oldField) =>
                    oldField.Id === field.Id
                        ? {
                            ...oldField,
                            Data,
                            touched: true,
                        }
                        : oldField
                )
            );
        };
    }
}
